import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withI18next } from 'lib/i18n/withI18next'
import Button from 'components/common/button'
import { BUTTON_TYPES } from 'constants/button'
import Router from 'next/router'
import StateStorage from 'lib/state-storage'
import clsx from 'clsx'
import Typo from 'constants/typography'
import ProductListSkeleton from 'components/product/product-list-skeleton'
import React, { useRef, useEffect } from 'react'
import useIntersection from 'components/custom-hooks/useIntersection'
import { getProductIDs } from 'lib/utils/handle-response'
import { segmentTrackProductListViewed } from 'lib/segment'
import {
  SEGMENT_REF_TYPES,
  SEGMENT_STORAGE_KEY_CATEGORY,
} from 'lib/segment/const'
import ProductListSlider from 'components/product/product-list-slider'
import homepageProductSliderOptions from '../../../product-presentation'
import styles from './best-sellers-quick-category.scss'

const BestSellersQuickCategory = ({ isPhone, bestSeller }) => {
  const bestSellersQuickCategoryRef = useRef(null)
  const isIntersecting = useIntersection(bestSellersQuickCategoryRef, {
    once: false,
  })
  const shop = StateStorage.getShop()
  const language = StateStorage.getLanguage()
  const cta = bestSeller?.cta
  const feedId = bestSeller?.id ?? ''

  const prepareCategoryReferer = (refId = '') => {
    sessionStorage.setItem(SEGMENT_STORAGE_KEY_CATEGORY.id, refId)
    sessionStorage.setItem(
      SEGMENT_STORAGE_KEY_CATEGORY.type,
      SEGMENT_REF_TYPES.APP_FEED,
    )
  }
  const handleClickSeeAll = () => {
    Router.push(
      `/category?id=${cta.value}`,
      `/${shop}/${language}/clothes/${cta.link_rewrite}`,
    )
    prepareCategoryReferer(feedId)
  }

  const showProducts = bestSeller?.products?.length !== 0
  const titles = bestSeller?.title?.split(':')
  const id_category = cta?.value ?? ''

  useEffect(() => {
    if (isIntersecting) {
      const productIds = getProductIDs(bestSeller?.products)
      segmentTrackProductListViewed(
        {
          id_site_category: id_category,
          page_number: 1,
          product_list_ids: productIds,
          site_category_name: cta?.link_rewrite || '',
        },
        {
          ref_type: SEGMENT_REF_TYPES.BEST_SELLERS,
          ref_id: feedId,
        },
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isIntersecting])

  return (
    <div
      ref={bestSellersQuickCategoryRef}
      className="best-sellers-quick-category-container"
    >
      <style jsx>{styles}</style>
      <div className="best-sellers-quick-category-container__titles-section">
        <div className="best-sellers-quick-category-container__titles">
          <span className={clsx(isPhone ? Typo.subtitle2 : Typo.title3)}>
            {titles[0]}:
          </span>
          <span
            className={clsx(
              isPhone ? Typo.body2 : Typo.caption,
              'best-sellers-quick-category-container__titles__sub-title',
            )}
          >
            {titles[1]}
          </span>
        </div>
        {isPhone && (
          <div className="best-sellers-quick-category-container__cta">
            <Button
              type={BUTTON_TYPES.outlinedLight}
              onClick={handleClickSeeAll}
            >
              {cta?.title}
            </Button>
          </div>
        )}
      </div>
      {showProducts ? (
        <div className="best-sellers-quick-category-product-list">
          <div className="best-sellers-quick-category-product-list__product-container">
            <ProductListSlider
              customArrowProps={{
                class: {
                  leftArrow:
                    'best-sellers-quick-category-product-list__prev-btn',
                  rightArrow:
                    'best-sellers-quick-category-product-list__next-btn',
                },
              }}
              isPhone={isPhone}
              displayBadges
              displaySwatches
              displayDescription
              displayWishlistIcon
              displayPrice={false}
              displayFlashSaleTitle
              displayBullets={false}
              displayManufacturerName
              displayQuickAddToCart={false}
              list={bestSeller?.products}
              slidesPerView={4}
              customSliderOptions={homepageProductSliderOptions}
              refType={SEGMENT_REF_TYPES.APP_FEED}
              refId={feedId}
            />
          </div>
        </div>
      ) : (
        <ProductListSkeleton number={4} workwearGrid />
      )}
      {!isPhone && (
        <div className="best-sellers-quick-category-container__cta">
          <Button type={BUTTON_TYPES.outlinedLight} onClick={handleClickSeeAll}>
            {cta?.title}
          </Button>
        </div>
      )}
    </div>
  )
}

BestSellersQuickCategory.defaultProps = {
  // refType: '',
  bestSeller: undefined,
}

BestSellersQuickCategory.propTypes = {
  // refType: PropTypes.string,
  isPhone: PropTypes.bool.isRequired,
  auth: PropTypes.shape({}).isRequired,
  bestSeller: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    cta: PropTypes.shape({
      kind: PropTypes.string,
      link_rewrite: PropTypes.string,
      title: PropTypes.string,
      value: PropTypes.string,
    }),
    products: PropTypes.arrayOf(PropTypes.shape({})),
  }),
}

export default compose(
  connect((state) => ({
    auth: state.auth,
    isPhone: state.device.isPhone,
  })),
  withI18next(),
)(BestSellersQuickCategory)
